import React, { useState } from "react"
import Select from "react-select"
import { defineMessages, injectIntl } from "react-intl"
import { SelectOption } from "../../state/helpers/SelectOption"
import IntlProps from "../../state/helpers/IntlProps"
import PriceLevel from "../../state/price-level/PriceLevel"
import { connect, ConnectedProps } from "react-redux"
import { getPriceLevels } from "../../state/price-level/PriceLevelSelector"

const messages = defineMessages({
    placeholder: {
        id: "product.price_level.price_level_select.placeholder",
        defaultMessage: "Select a Price Level"
    }
})

type OwnProps = {
    selectedPriceLevelId: string
    onChange: (value: string) => void
}

const PriceLevelSelect = (props: Props & IntlProps) => {
    const [selectedPriceLevelId, setSelectedPriceLevelId] = useState<string>(props.selectedPriceLevelId)
    const createOptions = (priceLevels: PriceLevel[]): SelectOption[] => {
        return priceLevels.map(pl => ({ label: pl.getName(), value: pl.getId() }))
    }

    const handleChange = (selectedOption: SelectOption) => {
        setSelectedPriceLevelId(selectedOption?.value as string)
        props.onChange(selectedOption?.value as string)
    }

    if (!props.priceLevels) {
        return <></>
    }

    const options = [...createOptions(props.priceLevels)]
    if (options.length === 0) {
        return <></>
    }

    return (
        <Select
            placeholder={props.intl.formatMessage(messages.placeholder)}
            clearable={true}
            searchable={true}
            value={selectedPriceLevelId}
            options={options}
            onChange={handleChange}
            className="drop-up"
        />
    )
}

const mapState = (state, props: OwnProps) => {
    return {
        ...props,
        priceLevels: getPriceLevels(state)
    }
}
const mapDispatch = {}
const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(PriceLevelSelect))



// WEBPACK FOOTER //
// ./src/product/price-level/PriceLevelSelect.tsx